import React from "react";
import SiteSection from "src/components/Site/SiteSection";

const SiteSettings = () => {
  return <SiteSection />;
};

export default SiteSettings;
